import _ from "lodash";
import { createSelector } from "reselect";
import { ORDER_TYPES } from "../../../../components/OrderTypeSelector/orderTypeSelectorConstants";
import {
    getLiteTradeAccountOrders,
    getLiteTradeAccountPositions,
    makeSelectorGetLiteTradeAccountOrderProtectionOrderInfoByType,
    makeSelectorGetLiteTradeAccountPositionProtectionOrderInfoByType
} from "../../../../modules/LiteTrade/liteTradeSelectors";
import type {
    ILiteTradeAssetSymbol,
    ILiteTradePortfolioOrder,
    ILiteTradePortfolioOrderType, ILiteTradePortfolioPosition,
} from "../../../../modules/LiteTrade/types/liteTradeReducer.t";
import { IMobileAppRootState } from "../../../types/mobileAppState.t";
import { TLiteTradePositionSide } from "../../../../modules/LiteTrade/liteTradeConstants";

export const makeSelectorMobilePositionUpdateProtectionOrderInfo = ({
    orderId,
    positionCode,
    protectionOrderType
}) => createSelector(
    [
        makeSelectorGetLiteTradeAccountOrderProtectionOrderInfoByType(orderId, protectionOrderType),
        makeSelectorGetLiteTradeAccountPositionProtectionOrderInfoByType(positionCode, protectionOrderType),
    ], (orderInfoByOrderId, orderInfoByPositionCode) => orderInfoByOrderId || orderInfoByPositionCode,
);

interface IGetMobilePositionUpdateInitialDataProps {
    positionCode: string,
    orderId: string,
}

interface IGetMobilePositionUpdateInitialDataOrderCommonResult {
    quantity: number,
    price: number,
    side: TLiteTradePositionSide,
    symbol: ILiteTradeAssetSymbol,
    type: ILiteTradePortfolioOrderType,
}

type IGetMobilePositionUpdateInitialDataOrderResult = IGetMobilePositionUpdateInitialDataOrderCommonResult & {
    orderCode: string,
}

type IGetMobilePositionUpdateInitialDataPositionResult = IGetMobilePositionUpdateInitialDataOrderCommonResult & {
    positionCode: string,
}

type IGetMobilePositionUpdateInitialDataReturn =
    (state: IMobileAppRootState, props: IGetMobilePositionUpdateInitialDataProps) =>
        IGetMobilePositionUpdateInitialDataOrderResult | IGetMobilePositionUpdateInitialDataPositionResult | {};

export const getMobilePositionUpdateInitialData: IGetMobilePositionUpdateInitialDataReturn = createSelector(
    getLiteTradeAccountOrders, getLiteTradeAccountPositions, (_, props) => props,
    (orders: ILiteTradePortfolioOrder[], positions: ILiteTradePortfolioPosition[], props: { orderId: string, positionCode: string }) => {
        const orderInfo = _.find(orders, { orderId: parseInt(props.orderId) }) as ILiteTradePortfolioOrder;
        const positionInfo = _.find(positions, { positionCode: props.positionCode }) as ILiteTradePortfolioPosition;
        if (orderInfo) {
            return {
                orderCode: orderInfo.orderCode,
                quantity: orderInfo.legs[0].quantity,
                price: orderInfo.legs[0].price,
                side: orderInfo.side,
                symbol: orderInfo.instrument,
                type: orderInfo.type,
            }
        } else if (positionInfo) {
            return {
                quantity: positionInfo.quantity,
                positionCode: positionInfo.positionCode,
                price: positionInfo.openPrice,
                side: positionInfo.side,
                symbol: positionInfo.symbol,
                type: ORDER_TYPES.MARKET,
            }
        }
        return {};
    }
)
